module.exports = __webpack_public_path__ + "img/hero-mobile@2x.1b8936a2.webp";